"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.OrthoTreatmentStatus_Factory = exports.Date_Factory = void 0;
var Date_Factory_1 = require("./Date_Factory");
Object.defineProperty(exports, "Date_Factory", { enumerable: true, get: function () { return Date_Factory_1.Date_Factory; } });
var OrthoTreatmentStatus_Factory = /** @class */ (function () {
    function OrthoTreatmentStatus_Factory() {
    }
    OrthoTreatmentStatus_Factory.CreateIncoming = function (model) {
        if (!model)
            return model;
        var result = {
            Description: model.Description,
            Name: model.Name,
            RecallDelay: model.RecallDelay,
            RecallDelayUnit: model.RecallDelayUnit,
            RecordCreated: Date_Factory_1.Date_Factory.CreateIncoming(model.RecordCreated),
            RecordId: model.RecordId,
            RecordLastUpdated: Date_Factory_1.Date_Factory.CreateIncoming(model.RecordLastUpdated),
            RecordStatus: model.RecordStatus,
            RequiresRecall: model.RequiresRecall,
        };
        return result;
    };
    OrthoTreatmentStatus_Factory.CreateOutgoing = function (model) {
        if (!model)
            return model;
        var result = {
            Description: model.Description,
            Name: model.Name,
            RecallDelay: model.RecallDelay,
            RecallDelayUnit: model.RecallDelayUnit,
            RecordCreated: Date_Factory_1.Date_Factory.CreateOutgoing(model.RecordCreated),
            RecordId: model.RecordId,
            RecordLastUpdated: Date_Factory_1.Date_Factory.CreateOutgoing(model.RecordLastUpdated),
            RecordStatus: model.RecordStatus,
            RequiresRecall: model.RequiresRecall,
        };
        return result;
    };
    return OrthoTreatmentStatus_Factory;
}());
exports.OrthoTreatmentStatus_Factory = OrthoTreatmentStatus_Factory;
